/**
 * trade
 * 支付API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The UseHistoryDto model module.
   * @module room/model/UseHistoryDto
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>UseHistoryDto</code>.
   * @alias module:room/model/UseHistoryDto
   * @class
   */
  var exports = function() {
    var _this = this;





  };

  /**
   * Constructs a <code>UseHistoryDto</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:room/model/UseHistoryDto} obj Optional instance to populate.
   * @return {module:room/model/UseHistoryDto} The populated <code>UseHistoryDto</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'roomId')) {
        obj['roomId'] = ApiClient.convertToType(data['roomId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'date')) {
        obj['date'] = ApiClient.convertToType(data['date'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'usedAmp')) {
        obj['usedAmp'] = ApiClient.convertToType(data['usedAmp'], 'Number');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'allAmp')) {
        obj['allAmp'] = ApiClient.convertToType(data['allAmp'], 'Number');
      }
    }
    return obj;
  }

  /**
   * 寝室id
   * @member {Integer} roomId
   */
  exports.prototype['roomId'] = undefined;
  /**
   * 日
   * @member {Date} date
   */
  exports.prototype['date'] = undefined;
  /**
   * 当日用电总量
   * @member {Number} usedAmp
   */
  exports.prototype['usedAmp'] = undefined;
  /**
   * 当日购电总量
   * @member {Number} allAmp
   */
  exports.prototype['allAmp'] = undefined;



  export default exports;
;


